import React from 'react'

import '../sass/dialog.scss'
import escapeHandler from '../lib/escape-handler'

interface DialogProps {
  title: string
  cancelText: string
  okText: string
  onCancelClick: () => void
  onOkClick: () => void
}

export const Dialog = ({ title, cancelText, okText, onCancelClick, onOkClick }) => {
  const firstButtonRef = React.useRef<HTMLButtonElement>()
  React.useEffect(() => {
    firstButtonRef.current.focus()
    const handleEscape = () => {
      onCancelClick()
    }
    escapeHandler.registerEscapeListener(handleEscape)
    return () => {
      escapeHandler.removeEscapeListener(handleEscape)
    }
  }, [])

  const handleCancelClick = (e: React.MouseEvent<HTMLElement>) => {
    onCancelClick()
  }

  const handleCancelKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onCancelClick()
    }
  }

  const handleOkClick = (e: React.MouseEvent<HTMLElement>) => {
    onOkClick()
  }

  const handleOkKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onOkClick()
    }
  }


  return (
    <div
      className='dialog'
      role='dialog'
      aria-labelledby='dialog-title'
    >
      <div id='dialog-title'>{title}</div>

      <div className='dialog-footer'>
        <button
          onClick={handleCancelClick}
          onKeyDown={handleCancelKeyDown}
          className='button secondary accentSecondary'
        >{cancelText}</button>
        <button
          ref={firstButtonRef}
          onClick={handleOkClick}
          onKeyDown={handleOkKeyDown}
          className='button primary accentPrimary'
        >{okText}</button>
      </div>
    </div>
  )
}
